














































import VueOptions from '@utils/VueOptions'
import RequestButton from '@/components/RequestButton'

settings =
  name: 'MeShow'
  resources:
    me: 
      resourceName: "me"
      slug: "me/:organizerId/edit"
  vue:
    store: ['member']
    components: { RequestButton }
    computed:
      organizerId: -> @member.organizer.id
      transferDayOptions: -> { disabledDate: @timeIsPast }
    data: ->
      cryoMe: null
      isEditing: false
    methods:
      timeIsPast: (time) -> time.getTime() < Date.now() - 8.64e7
      nevermindClicked: -> 
        @prime.me = @cryoMe
        @isEditing = false
      saveClicked: -> 
        @saveItem 'me', @prime.me
        @isEditing = false
    watch:
      isEditing: (newValue) ->
        @cryoMe = @cloneObject @prime.me
export default VueOptions.vue settings

